import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.PennyParka,
  voices: {
    main: {
      description:
        "teenage bright mezzo, fast city chatter, fearless homemade-tech enthusiasm, hoodie-muffled close mic, sparks of nervous laughter under confidence",
      seed: 10181,
      guidance: 0.76,
      loudness: 0.78,
      fx: { eq: "radio" },
    },
  },
  lines: {
    select: [
      {
        id: "select_1",
        text: "I'm here to finish the fight that my father began. I hope I make him proud.",
      },
      { id: "select_2", text: "SP//dr is all powered up!" },
      { id: "select_3", text: "I've got SP//dr on standby." },
      { id: "select_4", text: "Your girl Penny Parka is ready to go!" },
    ],
    spawn: [
      { id: "spawn_1", text: "Feel that energy, SP//dr? Time to let it flow!" },
      {
        id: "spawn_2",
        text: "We won't let you or Wakanda down, your majesty!",
      },
      {
        id: "spawn_3",
        text: "Watch your step! It's about to get real sticky around here!",
      },
      { id: "spawn_4", text: "Time for some major upgrades, right, Rocket?" },
      {
        id: "spawn_5",
        text: "This isn't my first trip through the multiverse, you know.",
      },
      {
        id: "spawn_6",
        text: "The Master Weaver is not going to be thrilled with me for jumping around realities…",
      },
      {
        id: "spawn_7",
        text: "I cannot let Doom do any more damage to the Web of Life and Destiny.",
      },
      {
        id: "spawn_8",
        text: "まあ, how can I focus in class when there's a HUMONGOUS CRACK in the sky?! Japanese: Maa / Oh, come on",
      },
      {
        id: "spawn_9",
        text: "Whoa. These chronal energy readings are gonna blow out your sensors, SP//dr!",
      },
      {
        id: "spawn_10",
        text: "なに, you were expecting Peter Parker? Please! Japanese: Nani / What",
      },
      {
        id: "spawn_11",
        text: "SP//dr is more than just a mechanized suit of armor. It's my best friend.",
      },
      {
        id: "spawn_12",
        text: "Most spiders just climb walls. I'm psionically linked to a giant robot. I win!",
      },
      {
        id: "spawn_13",
        text: "The spider controlling my suit is small, but fierce. Just like me.",
      },
      {
        id: "spawn_14",
        text: "The Web of Life and Destiny is fragile. Someone has to protect it.",
      },
      {
        id: "spawn_15",
        text: "What I do may seem dangerous, but I've never felt safer than when I'm with SP//dr.",
      },
      {
        id: "spawn_16",
        text: "My dad built SP//dr for himself, but I feel like I was born to pilot it.",
      },
      {
        id: "spawn_17",
        text: "Pretty sure I'm still the coolest spider-hero in any reality.",
      },
    ],
    respawn: [
      { id: "respawn_1", text: "We're back in action!" },
      { id: "respawn_2", text: "Just needed a few repairs." },
      {
        id: "respawn_3",
        text: "何だ, that doesn't count! Japanese: Nanda / What the—",
      },
      { id: "respawn_4", text: "Don't count us out yet!" },
      { id: "respawn_5", text: "Ready for another go, SP//dr?" },
    ],
    ult_ally: [{ id: "ult_ally", text: "SP//dr mode!" }],
    ult_enemy: [{ id: "ult_enemy", text: "It's SP//dr time!" }],
    ability2: [
      { id: "ability2_1", text: "Time for some fireworks!." },
      { id: "ability2_2", text: "This is gonna hurt." },
      { id: "ability2_3", text: "Mines in place." },
    ],
    ability1: [
      { id: "ability1_1", text: "You're up, little ones." },
      { id: "ability1_2", text: "I'm counting on you, friends." },
      { id: "ability1_3", text: "You know what to do, spiders." },
      { id: "ability1_4", text: "Spiders get the job done." },
      { id: "ability1_5", text: "Ooh! I know that sound!" },
      { id: "ability1_6", text: "My trap worked!" },
    ],
    kill: [
      { id: "kill_1", text: "SP//dr for the win!" },
      { id: "kill_2", text: "And that's how we do it in Tokyo." },
      { id: "kill_3", text: "It just wasn't your day." },
      { id: "kill_4", text: "さよなら! Japanese: Sayonara! / Goodbye!" },
      { id: "kill_5", text: "You never stood a chance." },
      { id: "kill_6", text: "Way to go, SP//dr!" },
    ],
    multikill: [
      { id: "multikill_1", text: "That makes three!" },
      {
        id: "multikill_2",
        text: "いち! に! さん! Japanese: Ichi! Ni! San! / One! Two! Three!",
      },
      { id: "multikill_3", text: "Three for me!" },
      { id: "multikill_4", text: "Five points for SP//dr!" },
      { id: "multikill_5", text: "I call this a winning streak!" },
      { id: "multikill_6", text: "We're on a roll, SP//dr!" },
      { id: "multikill_7", text: "Oh. Are we done now?" },
      { id: "multikill_8", text: "Wah? Was that really all of 'em?" },
      { id: "multikill_9", text: "やった! We win! Japanese: Yatta! / Yay!" },
    ],
    low_hp: [
      {
        id: "low_hp_1",
        text: "ありがとう! I needed that boost! Japanese: Arigatou! / Thank you!",
      },
      { id: "low_hp_2", text: "All systems go!" },
    ],
    healed: [
      { id: "healed_1", text: "Powering up…" },
      { id: "healed_2", text: "Systems restoring…" },
      { id: "healed_3", text: "I needed that!" },
      { id: "healed_4", text: "So much better!" },
    ],
  },
} satisfies VoiceScript;

export default script;
